/**
 * @generated SignedSource<<e2e04381f114151f4c216a6c690dc28e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgentPoolPageUnassignProjectFromAgentPoolMutation$variables = {
  agentPoolRawId: string;
  projectRawId: string;
  recursively?: boolean | null | undefined;
};
export type AgentPoolPageUnassignProjectFromAgentPoolMutation$data = {
  readonly unassignProjectFromAgentPool: {
    readonly agentPool: {
      readonly id: string;
      readonly projects: {
        readonly " $fragmentSpreads": FragmentRefs<"AgentPoolPageProjectsConnectionFragment">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AgentPoolPageUnassignProjectFromAgentPoolMutation = {
  response: AgentPoolPageUnassignProjectFromAgentPoolMutation$data;
  variables: AgentPoolPageUnassignProjectFromAgentPoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentPoolRawId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectRawId"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "recursively"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "agentPoolRawId",
        "variableName": "agentPoolRawId"
      },
      {
        "kind": "Variable",
        "name": "projectRawId",
        "variableName": "projectRawId"
      },
      {
        "kind": "Variable",
        "name": "recursive",
        "variableName": "recursively"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {}
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentPoolPageUnassignProjectFromAgentPoolMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "UnassignProjectFromAgentPoolPayload",
        "kind": "LinkedField",
        "name": "unassignProjectFromAgentPool",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentPool",
            "kind": "LinkedField",
            "name": "agentPool",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": (v5/*:: as any*/),
                "concreteType": "AgentPoolProjectsConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgentPoolPageProjectsConnectionFragment"
                  }
                ],
                "storageKey": "projects(filter:{})"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AgentPoolPageUnassignProjectFromAgentPoolMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "UnassignProjectFromAgentPoolPayload",
        "kind": "LinkedField",
        "name": "unassignProjectFromAgentPool",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentPool",
            "kind": "LinkedField",
            "name": "agentPool",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": (v5/*:: as any*/),
                "concreteType": "AgentPoolProjectsConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentPoolProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          (v6/*:: as any*/),
                          (v7/*:: as any*/),
                          (v8/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectPermissions",
                            "kind": "LinkedField",
                            "name": "permissions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "manageAgentPoolsForProject",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectAgentPoolsConnection",
                            "kind": "LinkedField",
                            "name": "agentPools",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectAgentPoolEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                      },
                                      (v4/*:: as any*/),
                                      (v6/*:: as any*/),
                                      (v7/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectsConnection",
                            "kind": "LinkedField",
                            "name": "ancestorProjects",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Project",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*:: as any*/),
                                      (v6/*:: as any*/),
                                      (v7/*:: as any*/),
                                      (v8/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(filter:{})"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fe0704a2fc59f36113009bc5896c4096",
    "id": null,
    "metadata": {},
    "name": "AgentPoolPageUnassignProjectFromAgentPoolMutation",
    "operationKind": "mutation",
    "text": "mutation AgentPoolPageUnassignProjectFromAgentPoolMutation(\n  $projectRawId: ID!\n  $agentPoolRawId: ID!\n  $recursively: Boolean = false\n) {\n  unassignProjectFromAgentPool(input: {projectRawId: $projectRawId, agentPoolRawId: $agentPoolRawId, recursive: $recursively}) {\n    agentPool {\n      id\n      projects(filter: {}) {\n        ...AgentPoolPageProjectsConnectionFragment\n      }\n    }\n  }\n}\n\nfragment AgentPoolPageProjectsConnectionFragment on AgentPoolProjectsConnection {\n  edges {\n    node {\n      id\n      rawId\n      name\n      archived\n      permissions {\n        manageAgentPoolsForProject\n      }\n      agentPools {\n        edges {\n          node {\n            __typename\n            id\n            rawId\n            name\n          }\n        }\n      }\n      ancestorProjects {\n        edges {\n          node {\n            id\n            rawId\n            name\n            archived\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c973176c58e120432191161f8ca80aa7";

export default node;
